import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  apiBaseUrl = environment.baseApiUrl;

  constructor(private http: HttpClient) { }

  getClientStudyData(
    data: {
      client_code: string;
      study: string;
    },
    isBrandAnalysis: boolean
  ): Observable<any> {
    let inputData = {
      client_code: data.client_code,
      study: data.study,
      is_brand_analysis: isBrandAnalysis,
    };
    return this.http
      .post<{ client_code: string; study: string; is_brand_analysis: boolean }>(
        this.apiBaseUrl + 'api/DataExplorer/getLeftPanelData',
        inputData
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Request error:', error);
          // You can handle the error here and throw a custom error if needed
          return throwError(error);
        })
      );
  }
}
